export default "__VITE_ASSET__DoPyqbnh__"